__turbopack_context__.v({
  "Loader__MainContainer": "Loader-module__qLSjJa__Loader__MainContainer",
  "Loader__MainContainer_TextPart": "Loader-module__qLSjJa__Loader__MainContainer_TextPart",
});
